import messages from "../components/messagesDescription";

export const getYearOptions = (formatMessage, range) => {
  const currentYear = new Date().getFullYear();
  return [
    { value: "", label: formatMessage(messages.yearDescription) },
    ...Array.from({ length: range }, (_, i) => {
      const year = currentYear - i;
      return { value: String(year), label: String(year) };
    }),
  ];
};

export const getMonthOptions = (formatMessage, maxMonth = 12) => {
  const allMonths = [
    { value: "", label: formatMessage(messages.monthDescription) },
    { value: "January", label: formatMessage({ id: "January", defaultMessage: "January" }) },
    { value: "February", label: formatMessage({ id: "February", defaultMessage: "February" }) },
    { value: "March", label: formatMessage({ id: "March", defaultMessage: "March" }) },
    { value: "April", label: formatMessage({ id: "April", defaultMessage: "April" }) },
    { value: "May", label: formatMessage({ id: "May", defaultMessage: "May" }) },
    { value: "June", label: formatMessage({ id: "June", defaultMessage: "June" }) },
    { value: "July", label: formatMessage({ id: "July", defaultMessage: "July" }) },
    { value: "August", label: formatMessage({ id: "August", defaultMessage: "August" }) },
    {
      value: "September",
      label: formatMessage({ id: "September", defaultMessage: "September" }),
    },
    { value: "October", label: formatMessage({ id: "October", defaultMessage: "October" }) },
    { value: "November", label: formatMessage({ id: "November", defaultMessage: "November" }) },
    { value: "December", label: formatMessage({ id: "December", defaultMessage: "December" }) },
  ];

  return allMonths.slice(0, maxMonth + 1); // +1 untuk include empty option
};

export const getDayOptions = (formatMessage, max = 31, currentDate = null) => {
  const baseOptions = [
    { value: "", label: formatMessage(messages.dayDescription) },
    ...Array.from({ length: max }, (_, i) => {
      const day = i + 1;
      return { value: String(day), label: String(day) };
    }),
  ];

  if (!currentDate) return baseOptions;

  // Filter out days in the future for current month/year
  return baseOptions.map(option => {
    if (!option.value) return option;
    const day = parseInt(option.value, 10);
    return {
      ...option,
      disabled: day > currentDate.getDate()
    };
  });
};

export const getDaysInMonth = (month, year = null) => {
  const monthIndex = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ].indexOf(month);

  if (monthIndex === -1) return 31;

  // Handle special cases when year is not selected
  if (year === null) {
    if (month === "February") {
      return 28; // Safe default for February without year
    }
    if (["April", "June", "September", "November"].includes(month)) {
      return 30;
    }
    return 31;
  }

  return new Date(year, monthIndex + 1, 0).getDate();
};

export const formatDateOfBirth = (day, month, year) => {
  if (!day || !month || !year) return null;

  const monthIndex = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ].indexOf(month);

  if (monthIndex === -1) return null;

  const formattedDay = day.toString().padStart(2, '0');
  const formattedMonth = (monthIndex + 1).toString().padStart(2, '0');

  return `${year}-${formattedMonth}-${formattedDay}`;
};



// WEBPACK FOOTER //
// ./utils/dateOptions.js